export enum FinancialAdvisorEvent {
  SHOW_REINVITED_REFERRAL_BANNER = 'FinancialAdvisorEvent:SHOW_REINVITED_REFERRAL_BANNER',
  REFRESH_TEAM_INVITES_WIDGET = 'FinancialAdvisorEvent:REFRESH_TEAM_INVITES_WIDGET',
  REFRESH_BILLING_DASHBOARD = 'FinancialAdvisorEvent:REFRESH_BILLING_DASHBOARD',
  MOVED_TO_TEAM = 'FinancialAdvisorEvent:MOVED_TO_TEAM',
  SCAN_COMPLETED = 'FinancialAdvisorEvent:SCAN_COMPLETED',
  SWITCH_TAB = 'FinancialAdvisorEvent:SWITCH_TAB',
  DOCUMENTS_LOADED = 'FinancialAdvisorEvent:DOCUMENTS_LOADED',
  DOCUMENT_ANALYSIS_UPDATED = 'FinancialAdvisorEvent:DOCUMENT_ANALYSIS_UPDATED'
}
